module.exports = __webpack_public_path__ + "static/img/restaurant-main-img02.d2e5b849.svg";